import { useState } from 'react';
import ClientApp from './ClientApp';
import OperatorApp from './OperatorApp';
import LoginPage, { Mode } from './pages/LoginPage';
import { getApiKey } from './services/api';
import { getOperatorToken } from './services/operatorApi';

function currentMode(): Mode | null {
  if (getOperatorToken()) return 'operator';
  if (getApiKey()) return 'client';
  return null;
}

export default function App() {
  const [mode, setMode] = useState<Mode | null>(currentMode);

  if (mode === 'operator') return <OperatorApp onLogout={() => setMode(null)} />;
  if (mode === 'client') return <ClientApp onLogout={() => setMode(null)} />;
  return <LoginPage onLoggedIn={setMode} />;
}
